'use client';

import { SignOutButton } from '@/components/assistant-ui/sign-out-button';
import { DevToolsButton } from '@/components/ui/dev-tools-button';
import { LanguageSelector } from '@/components/ui/language-selector';
import { ThemeToggle } from '@/components/ui/theme-toggle';

export function HeaderActions() {
  return (
    <div className="flex items-center gap-2">
      <LanguageSelector />
      <ThemeToggle />
      <DevToolsButton />
      <SignOutButton />
    </div>
  );
}
